import SkillGroupConstants from "../../../_shared/constants";

namespace SkillGroupChildrenGETConstants {
  export const MAX_LIMIT = SkillGroupConstants.MAX_LIMIT;
  export const DEFAULT_LIMIT = SkillGroupConstants.DEFAULT_LIMIT;
  export const MAX_CURSOR_LENGTH = SkillGroupConstants.MAX_CURSOR_LENGTH;
}
export default SkillGroupChildrenGETConstants;
